<template>
  <v-card>
    <v-card-text>
      <b-section-loader v-if="$loading.isLoading('orderSingle')" />
      <div v-else>
        <div class="d-flex justify-space-between align-center mb-3">
          <div class="font-weight-bold font-size-24">Накази</div>
          <v-btn-group
            color="surface"
            density="compact"
            divided
            rounded="xs"
            variant="flat">
            <v-btn
              v-if="false"
              class="mr-3"
              color="primary"
              rounded="lg"
              @click="createOrderTask">
              Створити доручення
              <v-icon class="ml-2" color="white">mdi-plus</v-icon>
            </v-btn>
            <b-action-menu
              :actions="[
                {
                  icon: 'mdi-delete-forever',
                  title: 'Видалити наказ',
                  action: deleteOrder,
                  disabled: false,
                  listItemProps: {
                    class: 'text-error',
                  },
                  iconProps: {
                    color: 'error',
                  },
                },
              ]">
            </b-action-menu>
          </v-btn-group>
        </div>
        <div class="d-flex align-center justify-space-between">
          <v-tabs
            color="primary"
            hide-slider
            style="border-bottom: 1px solid #e0e4e7">
            <v-tab
              :to="{
                name: 'order-general-info',
                params: { id: $route.params.id },
              }"
              replace>
              Основне
            </v-tab>
            <v-tab
              v-if="can('acknowledgments.viewAny')"
              :to="{ name: 'order-access', params: { id: $route.params.id } }"
              replace>
              Доступність
            </v-tab>
            <v-tab
              :to="{
                name: 'order-connections',
                params: { id: $route.params.id },
              }"
              replace>
              Зв'язки
            </v-tab>
            <v-tab
              v-if="false"
              :to="{ name: 'order-history', params: { id: $route.params.id } }"
              replace>
              Історія
            </v-tab>
            <v-tab
              v-if="false"
              :to="{ name: 'order-tasks', params: { id: $route.params.id } }"
              replace>
              Доручення
            </v-tab>
            <v-tab
              v-if="can('order-familiarizations.viewAny')"
              :to="{
                name: 'order-acknowledgment',
                params: { id: $route.params.id },
              }"
              replace>
              Ознайомлення
            </v-tab>
          </v-tabs>
          <div class="d-flex align-center gap-3">
            <v-menu v-if="!order.isActive" open-on-hover>
              <template #activator="{ props }">
                <v-btn
                  color="grey"
                  density="compact"
                  icon
                  v-bind="props"
                  variant="plain">
                  <v-icon>mdi-information-variant</v-icon>
                </v-btn>
              </template>

              <v-card>
                <v-card-text>
                  <div class="mb-2 d-flex align-center gap-2">
                    Актуальний наказ:
                    <span
                      v-if="order.actualOrder"
                      class="link"
                      style="
                        display: inline-block;
                        max-width: 300px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                      ">
                      {{ order.actualOrder.name }}
                    </span>
                    <span v-else> --- </span>
                  </div>
                  <div>Причина відмови: {{ order.deactivateComment }}</div>
                </v-card-text>
              </v-card>
            </v-menu>
            <div
              class="d-flex align-center gap-2 order__btn"
              @click="activityHandler">
              <v-progress-circular
                v-if="$loading.isLoading('activateOrder')"
                :size="18"
                :width="2"
                indeterminate></v-progress-circular>
              <span
                v-else
                :class="order.isActive ? 'green' : 'red'"
                class="mr-1 order__rounded"></span>
              <span
                :class="order.isActive ? 'order__active' : 'order__deactivate'">
                {{ order.isActive ? 'Активний' : 'Неактивний' }}
              </span>
            </div>
          </div>
        </div>
        <Skeleton v-if="$loading.isLoading('orderSingle')" />
        <router-view v-else></router-view>
        <div v-show="$route.name !== 'order-access'" class="d-flex justify-end">
          <SubmitButtons
            :disabled="!order.$hasChanges || !can('orders.update')"
            :loading="
              $loading.isLoading('orderUpdate') ||
              $loading.isLoading('orderSingle')
            "
            cancelLabel="Відмінити"
            class="mt-3"
            compact
            submitLabel="Оновити"
            @cancel="orderReset"
            @submit="orderUpdate" />
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import Skeleton from '@/components/Skeleton.vue'
import SubmitButtons from '@/components/SubmitButtons.vue'
import { useOrder } from './order'
import { navigateToItem } from '@/utils/helpers'
import { axios } from '@/plugins'
import { urlActivateOrder, urlOrderDelete } from '@/utils/urls'
import router from '@/router'
import { ref } from 'vue'
import { openDialog } from '@/dialog/index.ts'
import { confirm, handleAsync } from 'best-modules/plugins'
import { BActionMenu, BSectionLoader } from 'best-modules/components'
import { ENTITY_TYPE } from '@/utils/constants'
import { useCan } from '@/composables/useCan'

export default {
  components: {
    BActionMenu,
    Skeleton,
    SubmitButtons,
    BSectionLoader,
  },
  setup() {
    const { can } = useCan()
    const { order, orderUpdate, orderReset } = useOrder()

    const deleteOrder = () => {
      can('orders.delete', () => {
        confirm({
          text: 'Ви впевненні що хочете видалити наказ на завжди?',
        }).then(() => {
          return axios.delete(urlOrderDelete(order.id)).then(() => {
            return router.push({ name: 'order-list' })
          })
        })
      })
    }

    const orderActiveLoading = ref(false)

    const activityHandler = () => {
      if (order.isActive) {
        return openDeactivateOrderDialog()
      } else {
        return activateOrder()
      }
    }

    const activateOrder = () => {
      can('orders.activate', () => {
        return handleAsync('activateOrder', () => {
          return axios.patch(urlActivateOrder(order.id)).then(res => {
            order.$set(res.data)
          })
        })
      })
    }

    const createOrderTask = () => {
      can('tasks.create', () => {
        openDialog({
          name: 'CreateTask',
          dialogData: {
            taskData: {
              typeId: 3,
              entityTypeId: ENTITY_TYPE.ORDER,
              entityId: order.id,
              name: order?.name,
            },
          },
          params: {},
        })
      })
    }

    const openDeactivateOrderDialog = () => {
      can('orders.deactivate', () => {
        openDialog({
          name: 'OrderDeactivate',
          dialogData: {
            orderId: order.id,
          },
          params: {
            cb(updatedOrder) {
              order.$set(updatedOrder)
            },
          },
        })
      })
    }

    return {
      navigateToItem,
      deleteOrder,
      orderActiveLoading,
      activityHandler,
      order,
      orderUpdate,
      orderReset,
      createOrderTask,
      can,
    }
  },
}
</script>

<style lang="scss" scoped>
.order {
  &__btn {
    background: transparent;
    transition: 0.3s;
    padding: 4px 12px;
    border-radius: 4px;
    cursor: pointer;

    &:hover {
      background: #e1e1e1;
    }
  }

  &__active {
    color: #35ab8f;
    font-size: 14px;
    font-weight: 600;
  }

  &__deactivate {
    color: #ff8473;
    font-size: 14px;
    font-weight: 600;
  }

  &__rounded {
    width: 8px;
    height: 8px;
    display: block;
    border-radius: 50%;

    &.green {
      background: #35ab8f;
    }

    &.red {
      background: #ff8473;
    }
  }
}
</style>
